import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/auth';
import { userInfo, userGetInfo } from '../actions/user';
import { post, get } from '../../utils/api';

export function* auth({ payload, history }) {
  try {
    const response = yield call(post,
      '/login',
      {
        username: payload.Username,
        password: payload.Password
      });
    localStorage.setItem('userInfo', JSON.stringify(response));
    yield put(userInfo(response));
    yield put(userGetInfo());
    yield put(actions.authSuccess());
    yield call(history.push, '/stock');
  } catch (e) {
    if (e.response.status === 401) {
      const err = e.response.data || {};
      if (err.message === 'undefined') {
        err.message = formatMessage('textIncorrect');
      }
      yield put(actions.authFail(err));
    } else {
      yield put(actions.authFail(true));
    }
  }
}

export function* getUrlWebSSOLogin({ payload }) {
  try {
    const response = yield call(get, '/public/sso-login-link');
    yield put(actions.getUrlWebSSOLoginSuccess(response));
  } catch (e) {
    yield put(actions.getUrlWebSSOLoginFail());
  }
}

export function* getUrlWebSSOLogout({ payload }) {
  try {
    const response = yield call(get, '/public/sso-logout-link');
    yield put(actions.getUrlWebSSOLogoutSuccess(response));
  } catch (e) {
    yield put(actions.getUrlWebSSOLogoutFail());
  }
}
